import { useEffect, useState } from 'react'
import type { NewsArticle } from 'prove-common'

/** First non-empty line of the markdown body, without its heading markers. */
export const newsSummary = (article: NewsArticle) =>
  article.subject
    .split('\n')
    .map((line) => line.replace(/^#+\s*/, '').trim())
    .find(Boolean) ?? 'Uten overskrift'

export const newsAppLabel = (app: string) =>
  app === 'ProveTa' ? 'PrøveTa' : app === 'ProvePlan' ? 'PrøvePlan' : app

/** Body without the title already rendered as the article page's `h1`. */
export const newsBody = (article: NewsArticle) =>
  newsArticleBody(article.subject)

export const newsTypeLabel = (icon: string) =>
  icon === 'bug' ? 'Feilretting' : icon === 'merge' ? 'Nye funksjoner' : icon

export const newsArticleBody = (subject: string) => {
  const lines = subject.split('\n')
  const first = lines.findIndex((line) => line.trim())
  if (first < 0) return ''
  // Only a real Markdown heading is used as the page title. Plain text,
  // lists, code fences, and other Markdown must remain in the article body.
  if (!/^#{1,6}\s+\S/.test(lines[first].trim())) return subject.trim()
  return lines
    .slice(first + 1)
    .join('\n')
    .trim()
}

/**
 * Availability flips without user interaction, so re-evaluate every minute
 * instead of leaving a stale status behind on a long-lived list.
 */
export const useNewsExpired = (endDate: string | undefined) => {
  const [now, setNow] = useState(Date.now)

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 60_000)
    return () => window.clearInterval(timer)
  }, [])

  return endDate != null && Date.parse(endDate) < now
}
